"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommandId = void 0;
const utils_1 = require("ethers/lib/utils");
const getCommandId = (chainName, txHash, sourceEventIndex, environment, rpcInfo) => {
    var _a;
    const chainID = (_a = rpcInfo[environment].networkInfo[chainName.toLowerCase()]) === null || _a === void 0 ? void 0 : _a.chainId;
    if (!chainID)
        return "";
    const seiArr = (0, utils_1.arrayify)(sourceEventIndex).reverse();
    const txHashWithEventIndex = new Uint8Array([
        ...(0, utils_1.arrayify)(txHash),
        ...new Uint8Array(8).map((a, i) => seiArr[i] || a),
    ]);
    const chainIdByteArray = (0, utils_1.arrayify)(chainID);
    const dataToHash = new Uint8Array(txHashWithEventIndex.length + chainIdByteArray.length);
    dataToHash.set(txHashWithEventIndex, 0);
    dataToHash.set(chainIdByteArray, txHashWithEventIndex.length);
    return (0, utils_1.keccak256)(dataToHash).slice(2); // remove 0x prefix
};
exports.getCommandId = getCommandId;
//# sourceMappingURL=getCommandId.js.map